module.exports = __webpack_public_path__ + "img/catering.1e03238b.png";